module.exports = __webpack_public_path__ + "static/media/APP_RisingStar_152x174_5.91f55f92.png";